/* eslint-disable react/prop-types */
import React from 'react';
import { Grid, TextField, FormLabel, Typography, Box } from '@mui/material';
import { Field, ErrorMessage } from 'formik';
import SubCard from 'ui-component/cards/SubCard';
import HelpIcon from './HelpIcon';
import { tips } from './HelpData';

export default function AgentOfficeInformation({ role, values, handleChange, handleBlur, errors, touched }) {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography
                    sx={{
                        color: '#919191',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '700',
                        lineHeight: 'normal',
                        textTransform: 'capitalize',
                        my: 2
                    }}
                >
                    Agent/Office Information
                </Typography>
                <SubCard sx={{ mt: '20px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={5}>
                            <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                        List Agent MLS ID
                                    </Typography>
                                </FormLabel>
                                <HelpIcon
                                    title={tips?.listAgentMLSID.title}
                                    ruleHelp={tips?.listAgentMLSID.ruleHelp}
                                    generalHelpDesc={tips?.listAgentMLSID.generalHelpDesc}
                                />
                            </Box>

                            <Field
                                as={TextField}
                                fullWidth
                                name="listAgentMLSID"
                                variant="outlined"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.listAgentMLSID}
                                error={touched.listAgentMLSID && errors.listAgentMLSID}
                                helperText={<ErrorMessage name="listAgentMLSID" />}
                            />
                        </Grid>

                        <Grid item xs={12} sm={5}>
                            <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                        Co List Agent MLS ID
                                    </Typography>
                                </FormLabel>
                                <HelpIcon
                                    title={tips?.coListAgentMLSID.title}
                                    ruleHelp={tips?.coListAgentMLSID.ruleHelp}
                                    generalHelpDesc={tips?.coListAgentMLSID.generalHelpDesc}
                                />
                            </Box>
                            <Field
                                as={TextField}
                                fullWidth
                                name="coListAgentMLSID"
                                variant="outlined"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.coListAgentMLSID}
                                error={touched.coListAgentMLSID && errors.coListAgentMLSID}
                                helperText={<ErrorMessage name="coListAgentMLSID" />}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            {/* <Typography>Agent Name and Information</Typography> */}
                            {/* <Typography>
                                {user?.firstName || ''} {user?.lastName || ''}
                            </Typography>
                            <Typography>{user?.phoneNo || ''}</Typography>
                            <Typography>{user?.email || ''}</Typography> */}
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            {/* <Typography>Office Name and Information</Typography> */}
                            {/* <Typography>
                                {user?.firstName || ''} {user?.lastName || ''}
                            </Typography>
                            <Typography>{user?.phoneNo || ''}</Typography>
                            <Typography>{user?.email || ''}</Typography> */}
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            {/* <Typography>Co Agent Name and Information</Typography> */}
                            {/* <Typography>{user?.address || ''}</Typography> */}
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            {/* <Typography>Co Office Name and Information</Typography> */}
                            {/* <Typography>
                                {user?.firstName || ''} {user?.lastName || ''}
                            </Typography>
                            <Typography>{user?.phoneNo || ''}</Typography>
                            <Typography>{user?.email || ''}</Typography> */}
                        </Grid>
                    </Grid>
                </SubCard>
            </Grid>

            {/* {role === roles.ADMIN && (
                <Grid item xs={12}>
                    <SubCard title="Compensation Information" sx={{ mt: '20px' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={3}>
                                <FormControl fullWidth required variant="outlined">
                                    <InputLabel>Sub Agency Compensation Type</InputLabel>
                                    <Field
                                        as={Select}
                                        name="subAgencyCompType"
                                        value={values.subAgencyCompType}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        input={<OutlinedInput label="Sub Agency Compensation Type" />}
                                        error={touched.subAgencyCompType && errors.subAgencyCompType}
                                        required
                                    >
                                        <MenuItem value="$">$</MenuItem>
                                        <MenuItem value="%">%</MenuItem>
                                    </Field>
                                    {touched.subAgencyCompType && errors.subAgencyCompType && (
                                        <FormHelperText sx={{ color: 'red' }}>{errors.subAgencyCompType}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={6} sm={3}>
                                <Field
                                    as={TextField}
                                    fullWidth
                                    name="subAgencyComp"
                                    label="Sub Agency Compensation"
                                    variant="outlined"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.subAgencyComp}
                                    error={touched.subAgencyComp && errors.subAgencyComp}
                                    helperText={<ErrorMessage name="subAgencyComp" />}
                                    required
                                />
                            </Grid>

                            <Grid item xs={6} sm={3}>
                                <FormControl fullWidth required variant="outlined">
                                    <InputLabel>Buyer Agency Compensation Type</InputLabel>
                                    <Field
                                        as={Select}
                                        name="buyerAgencyCompType"
                                        value={values.buyerAgencyCompType}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        input={<OutlinedInput label="Buyer Agency Compensation Type" />}
                                        error={touched.buyerAgencyCompType && errors.buyerAgencyCompType}
                                        required
                                    >
                                        <MenuItem value="$">$</MenuItem>
                                        <MenuItem value="%">%</MenuItem>
                                    </Field>
                                    {touched.buyerAgencyCompType && errors.buyerAgencyCompType && (
                                        <FormHelperText sx={{ color: 'red' }}>{errors.buyerAgencyCompType}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={6} sm={3}>
                                <Field
                                    as={TextField}
                                    fullWidth
                                    name="buyerAgencyComp"
                                    label="Buyer Agency Compensation"
                                    variant="outlined"
                                    required
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.buyerAgencyComp}
                                    error={touched.buyerAgencyComp && errors.buyerAgencyComp}
                                    helperText={<ErrorMessage name="buyerAgencyComp" />}
                                />
                            </Grid>

                            <Grid item xs={6} sm={3}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel>Bonus to BA</InputLabel>
                                    <Field
                                        as={Select}
                                        name="bonusToBA"
                                        value={values.bonusToBA}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        input={<OutlinedInput label="Bonus to BA" />}
                                        error={touched.bonusToBA && errors.bonusToBA}
                                    >
                                        <MenuItem value="$">$</MenuItem>
                                        <MenuItem value="%">%</MenuItem>
                                    </Field>
                                    <ErrorMessage name="bonusToBA" component="div" />
                                </FormControl>
                            </Grid>

                            <Grid item xs={6} sm={3}>
                                <Field
                                    as={TextField}
                                    fullWidth
                                    name="bonusToBAAmount"
                                    label="Bonus to BA Amount"
                                    variant="outlined"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.bonusToBAAmount}
                                    error={touched.bonusToBAAmount && errors.bonusToBAAmount}
                                    helperText={<ErrorMessage name="bonusToBAAmount" />}
                                />
                            </Grid>

                            <Grid item xs={6} sm={3}>
                                <FormControl fullWidth required variant="outlined">
                                    <InputLabel>Dual Variable Compensation</InputLabel>
                                    <Field
                                        as={Select}
                                        name="dualVariableComp"
                                        value={values.dualVariableComp}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        input={<OutlinedInput label="Dual Variable Compensation" />}
                                        error={touched.dualVariableComp && errors.dualVariableComp}
                                        required
                                    >
                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                    </Field>
                                    {touched.dualVariableComp && errors.dualVariableComp && (
                                        <FormHelperText sx={{ color: 'red' }}>{errors.dualVariableComp}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={6} sm={3}>
                                <FormControl fullWidth required variant="outlined">
                                    <InputLabel>Intermediary</InputLabel>
                                    <Field
                                        as={Select}
                                        name="intermediary"
                                        value={values.intermediary}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        input={<OutlinedInput label="Intermediary" />}
                                        error={touched.intermediary && errors.intermediary}
                                        required
                                    >
                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                    </Field>
                                    {touched.intermediary && errors.intermediary && (
                                        <FormHelperText sx={{ color: 'red' }}>{errors.intermediary}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </SubCard>
                </Grid>
            )} */}

            <Grid item xs={12}>
                <Typography
                    sx={{
                        color: '#919191',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '700',
                        lineHeight: 'normal',
                        textTransform: 'capitalize',
                        my: 2
                    }}
                >
                    Attribution Contact
                </Typography>
                <SubCard sx={{ mt: '20px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography>
                                Attribution Contact is the additional contact information from the listing brokerage which will appear on
                                IDX and VOW websites. Your office default contact information is shown below (ex. Office Phone).
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Box sx={{ mb: 1, display: 'flex', justifyItems: 'center' }}>
                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                        Listing Override
                                    </Typography>
                                </FormLabel>
                                <HelpIcon
                                    title={tips?.listingOverride.title}
                                    ruleHelp={tips?.listingOverride.ruleHelp}
                                    generalHelpDesc={tips?.listingOverride.generalHelpDesc}
                                />
                            </Box>
                            <Field
                                as={TextField}
                                fullWidth
                                required
                                name="listingOverride"
                                variant="outlined"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.listingOverride}
                                error={touched.listingOverride && errors.listingOverride}
                                helperText={<ErrorMessage name="listingOverride" />}
                            />
                        </Grid>

                        <Typography variant="caption" color="error" sx={{ p: 2 }}>
                            This field will only be fillable if your broker has allowed for listing agent override of their office’s default
                            selection. If fillable and if you’d like to change your broker’s default selection, only enter in an email
                            (email@address.com) or a phone number (512-555-5555).
                        </Typography>

                        <Typography sx={{ p: 2, fontWeight: '600' }}>Office Default Phone Number - (512) 387-5314</Typography>
                    </Grid>
                </SubCard>
            </Grid>
        </Grid>
    );
}
